import { JSX } from 'react';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { GetHeroBannerModel } from './B01HeroBanner.service';
import { B01HeroBannerProps } from './B01HeroBanner.type';
import { HeroBanner } from '@ahc-digital/component-library';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

const Default = (props?: B01HeroBannerProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <HeroBanner
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...GetHeroBannerModel(props)}
    />
  );
};

export default checkDatasourceForRendering<B01HeroBannerProps>(Default);
